module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "text-poppins-16 my-2 pt-2"
  }, [_vm._v("New Releases")]), _vm._v(" "), _c('div', {
    staticClass: "horizontal-scroll"
  }, _vm._l((5), function(i) {
    return _c('div', {
      key: i,
      staticClass: "horizontal-scroll__item mr-2 mb-2"
    }, [_vm._m(1, true), _vm._v(" "), _c('div', {
      staticClass: "font-15 font-weight-500 text-white"
    }, [_vm._v("Amazing")]), _vm._v(" "), _c('div', {
      staticClass: "text-grey-4 font-15 font-weight-500"
    }, [_vm._v("Nighttime")])])
  })), _vm._v(" "), _c('div', {
    staticClass: "text-poppins-16 my-2"
  }, [_vm._v("Playlists")]), _vm._v(" "), _c('div', {
    staticClass: "horizontal-scroll"
  }, _vm._l((5), function(i) {
    return _c('div', {
      key: i,
      staticClass: "horizontal-scroll__item mr-2 mb-2"
    }, [_vm._m(2, true), _vm._v(" "), _c('div', {
      staticClass: "font-15 font-weight-500 text-white"
    }, [_vm._v("Rap Jams")])])
  })), _vm._v(" "), _c('div', {
    staticClass: "text-poppins-16 font-weight-700 my-2"
  }, [_vm._v("YOUR ALBUMS")]), _vm._v(" "), _c('div', {
    staticClass: "horizontal-scroll"
  }, _vm._l((5), function(i) {
    return _c('div', {
      key: i,
      staticClass: "horizontal-scroll__item mr-2 mb-2"
    }, [_vm._m(3, true), _vm._v(" "), _c('div', {
      staticClass: "font-15 font-weight-500 text-white"
    }, [_vm._v("Title")]), _vm._v(" "), _c('div', {
      staticClass: "text-grey-4 font-15 font-weight-500"
    }, [_vm._v("Artist name")])])
  })), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._l((5), function(i) {
    return _c('div', {
      key: i,
      staticClass: "my-4 display-flex align-center gap-8"
    }, [_vm._m(5, true), _vm._v(" "), _vm._m(6, true)])
  })], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "display-flex justify-space-between align-center mb-3"
  }, [_c('div', {
    staticClass: "display-flex gap-8 align-center"
  }, [_c('div', {
    staticClass: "library__title"
  }, [_vm._v("Library")])]), _vm._v(" "), _c('div', {
    staticClass: "library__select font-weight-500"
  }, [_vm._v("Create")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    attrs: {
      "src": require("../../assets/mobile/library_1.png"),
      "width": "151",
      "height": "151"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    attrs: {
      "src": require("../../assets/mobile/library_2.jpg"),
      "width": "151",
      "height": "151"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    attrs: {
      "src": require("../../assets/mobile/library_3.jpg"),
      "width": "151",
      "height": "151"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "my-4 display-flex justify-space-between align-center"
  }, [_c('div', {
    staticClass: "text-poppins-16 text-white"
  }, [_vm._v("Tracks (1,239)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    attrs: {
      "src": require("../../assets/mobile/library_4.jpg"),
      "width": "48",
      "height": "48"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "text-poppins-16 text-white"
  }, [_vm._v("Never gonna give you up")]), _vm._v(" "), _c('div', {
    staticClass: "display-flex align-center gap-4"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/mobile/icon/download-circle.svg"),
      "width": "16",
      "height": "16"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "text-poppins-14 font-weight-500 text-grey-5"
  }, [_vm._v("\n          Rick Astley\n        ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-47d8ff06","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/new-mobile/library.vue
// module id = 1709
// module chunks = 180